module.exports = __webpack_public_path__ + "img/SGS_book.65824297.png";